"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const versioned = [{
  minmax: [0, 299],
  types: {
    RefCount: 'RefCountTo259'
  }
}, {
  minmax: [300, 399],
  types: {
    CurrencyId: {
      _enum: ['LAMI', 'AUSD', 'FEUR', 'FJPY', 'FBTC', 'FETH', 'FAUD', 'FCAD', 'FCHF', 'FXAU', 'FOIL', 'FGBP']
    }
  }
}, {
  minmax: [400, undefined],
  types: {}
}];
var _default = versioned;
exports.default = _default;